import suggestionTypes from "../constants/suggestionTypes";

export default function constructKeywordFilter(keyword) {
  return {
    type: suggestionTypes.keyword,
    id: `kw:${keyword}`,
    name: "Keyword",
    style: "text",
    display: keyword,
    value: keyword,
  };
}
